import React, { useState } from "react";
import { api } from "../../../lib/api";
import { toast } from "sonner";

export const GuideSimulator = () => {
  const [text, setText] = useState("Quanto estou devendo?");
  const [res, setRes] = useState(null);
  const run = async () => {
    try { setRes((await api.post("/admin/wa-portal-guide/simulate", { text })).data); }
    catch { toast.error("Falha na simulação"); }
  };
  return (
    <section className="border border-[#EBE5DF] bg-white p-6" data-testid="wpg-simulator-section">
      <h2 className="text-lg font-semibold mb-1">Simulador (sem envio)</h2>
      <p className="text-xs text-[#5C5A57] mb-3">Mostra o texto-base que a IA usaria. Nada é enviado nem registrado.</p>
      <div className="flex gap-2">
        <input value={text} onChange={(e) => setText(e.target.value)} className="flex-1 border px-3 py-2 text-sm" data-testid="wpg-sim-input" />
        <button onClick={run} className="bg-[#1A1A1A] px-4 text-sm text-white" data-testid="wpg-sim-run">Simular</button>
      </div>
      {res && (
        <div className="mt-4 space-y-2 text-sm" data-testid="wpg-sim-result">
          {res.reply ? <pre className="whitespace-pre-wrap bg-[#FBF8F5] p-3 font-sans" data-testid="wpg-sim-reply">{res.reply}</pre>
            : <div className="text-[#5C5A57]" data-testid="wpg-sim-not-handled">{res.note}</div>}
          {res.intent && <div className="text-xs text-[#5C5A57]" data-testid="wpg-sim-intent">
            Assuntos: {res.intent.topics.join(", ") || "—"} · Acesso: {res.intent.access ? "sim" : "não"} · Comercial: {res.intent.commercial ? "sim" : "não"}
            {res.handoff ? ` · Encaminhamento: ${res.handoff}` : ""}</div>}
        </div>
      )}
    </section>
  );
};
